import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardNumberInput: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardNumberInput_dataBinding_panelTitle',
    helpId: '3f78508c-c1dd-44c7-a780-ec4b34e5bfe0',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardNumberInputRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardNumberInput_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardNumberInput_dataBinding_placeholder_label',
          prop: 'placeholder',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardNumberInput_dataBinding_tooltip_label',
          prop: 'tooltip',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardNumberInput_dataBinding_min_label',
          prop: 'min',
          supportedFieldTypes: [FieldType.number],
          defaultFieldType: FieldType.number,
        },
        {
          title: 'dsgnsys_DashboardNumberInput_dataBinding_max_label',
          prop: 'max',
          supportedFieldTypes: [FieldType.number],
          defaultFieldType: FieldType.number,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
